<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="closePopup()">
    <d-modal-header>
      <d-modal-title>
        {{ $t('longRealizedOrdersPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table table-stripes">
        <thead>
          <tr>
            <td>{{ $t('longRealizedOrdersPopup.order') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.status') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.created') }}</td>
            <td>{{ $t('longRealizedOrdersPopup.modified') }}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(order, index) of extendedOrders"
            :key="'order-' + index">
            <td>
              <router-link
                :to="'/zamowienia/edycja/' + order.id"
                target="_blank">
                {{ order.order_name }}
              </router-link>
            </td>
            <td>
              <status-badge
                :status="order.status" />
            </td>
            <td>
              {{ order.created_at.replace('T', ' ').replace('.000000Z', '') }} ({{ order.created_days }} {{ $t('ui.days') }})
            </td>
            <td>
              {{ order.updated_at.replace('T', ' ').replace('.000000Z', '') }} ({{ order.updated_days }} {{ $t('ui.days') }})
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
import StatusBadge from './../common/StatusBadge.vue';

export default {
  name: 'long-realized-orders-popup',
  props: [
    'orders',
  ],
  components: {
    'status-badge': StatusBadge
  },
  computed: {
    extendedOrders () {
      let currentDate = new Date();

      return this.orders.map(order => {
        let createdDate = new Date(order.created_at);
        let updatedDate = new Date(order.updated_at);
        let createdTimeDiff = currentDate - createdDate;
        let updatedTimeDiff = currentDate - updatedDate;
        order.created_days = Math.floor(createdTimeDiff / (24 * 60 * 60 * 1000));
        order.updated_days = Math.floor(updatedTimeDiff / (24 * 60 * 60 * 1000));
        return order;
      }).reverse();
    }
  },
  methods: {
    closePopup () {
      this.$bus.$emit('dashboard-long-realized-orders-popup-close');
    }
  }
}
</script>
